var headerTemplate = `
<div class="header-text">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 291 93"><path fill-rule="evenodd" clip-rule="evenodd" fill="#FEFEFE" d="M180.731 52c0-3.863-2.569-7.152-6.731-7.152s-6.731 3.289-6.731 7.152 2.569 7.152 6.731 7.152 6.731-3.289 6.731-7.152M187 52c0 7.257-5.755 13-13 13s-13-5.743-13-13c0-7.309 5.755-13 13-13s13 5.691 13 13M208 39.741l-2.197 5.333s-1.151-.543-2.982-.543c-3.818 0-5.544 3.161-5.544 3.161V63H191V39.593h5.963V43s2.145-4 6.748-4c2.249 0 4.289.741 4.289.741M209 40.196h4.537V33h5.854v7.196h6.975v5.512h-6.975v9.748c0 2.961 1.463 3.828 3.024 3.828 1.317 0 2.439-.868 2.439-.868L227 63.418S224.805 65 221.439 65c-4.488 0-7.903-3.419-7.903-8.574V45.708H209v-5.512zM233.501 55.968s3.292 3.55 7.473 3.55c2.56 0 4.703-.731 4.703-2.245 0-1.618-1.15-1.932-4.912-2.715-4.912-1.044-9.197-3.132-9.197-7.831 0-3.863 3.867-7.727 10.661-7.727 5.591 0 9.302 3.028 9.302 3.028l-3.136 4.594s-2.822-2.14-6.166-2.14c-2.352 0-4.494.835-4.494 2.349 0 1.514 1.673 1.88 5.853 2.767 4.912 1.044 8.413 2.662 8.413 7.779 0 4.229-4.494 7.623-10.817 7.623C233.919 65 230 60.51 230 60.51l3.501-4.542zM273.962 49.703c-.101-2.141-2.013-5.012-5.987-5.012-3.874 0-5.635 2.819-5.837 5.012h11.824zM280 51.896c0 .47 0 1.41-.05 2.349h-17.811c.453 2.193 2.918 5.012 6.692 5.012 4.176 0 6.541-2.506 6.541-2.506l3.019 4.699s-3.774 3.55-9.56 3.55C261.585 65 256 59.257 256 52s5.081-13 11.975-13C274.515 39 280 44.273 280 51.896zM285 65h6V26h-6zM79 5.035L35.79.092A14.178 14.178 0 0024 4.311L51.735 47 79 5.035zM2.392 36.215a13.946 13.946 0 00-.275 15.198L10 64V25L2.392 36.215z"/><path fill-rule="evenodd" clip-rule="evenodd" fill="#FEFEFE" d="M98.841 25.449L93.482 17v46.974H78.54V31.747L51.27 72.801 24 31.747v56.097a14.16 14.16 0 0012.842 5.027l46.124-6.257a7.353 7.353 0 01-4.442-6.776c0-4.124 3.313-7.405 7.479-7.405s7.479 3.281 7.479 7.405c0 .094-.011.184-.014.278a13.822 13.822 0 002.016-5.538l5.391-39.854a13.841 13.841 0 00-2.034-9.275M126.566 30L138 47.6 149.434 30H155v35h-6.018V41.5L138 58.15 127.018 41.5V65H121V30z"/></svg>
<h1>PODIUMAANBOD</h1>
</div>
`;

var filterTemplate = `
<% for (filter in this.filters) {%>
    <div class="field">
      <label class="checkbox">
      <input type="radio" name="Genre" value="<%this.filters[filter].value%>" class="js-genre-filter" data-value="<%this.filters[filter].text%>" <%if (this.filters[filter].selected){%>checked="true"<%}%>">
          <%this.filters[filter].text%>
      </label>
    </div>
<% } %>
    `;

var itemTemplate =
  `<div class="list-item info clearfix columns">
    <a href="<%this.detailsLink%>" class="column is-3 image-wrapper">
      <div class="image-container" style="background-image: url('<%this.imageSrc%>');" >
          <div class="status <%this.statusSlug%>"><%this.status%></div>
      </div>
    </a>

    <div class="text-content column columns is-gapless is-multiline">
        <a href="<%this.detailsLink%>" class="column is-full  title-link-wrapper">
            <h3 class="datum"><%this.datum%> UUR</h3>
            <h2><%this.titel%></h2>
            <% if (this.subtitel) {%>
            <h4><%this.subtitel%></h4>
            <% } %>
        </a>
        <%if (this.locatie) { %>
        <div class="column is-full location">
                <span class="label locationlabel"><svg width="14" height="19" xmlns="http://www.w3.org/2000/svg"><path
                    d="M13.966 7.102A6.951 6.951 0 007 .137 6.951 6.951 0 00.034 7.102C.034 10.961 7 18.166 7 18.166s6.966-7.205 6.966-11.064zm-10.21-.136A3.265 3.265 0 017 3.722a3.242 3.242 0 013.244 3.244A3.242 3.242 0 017 10.21a3.265 3.265 0 01-3.244-3.244z"
                    fill="#076581" fill-rule="nonzero"/></svg></span> <span><%this.locatie%></span>
        </div>
        <%}%>
        <div class="column is-full">
          <span class="genre js-genre-click" data-value="<%this.genre%>">
              <%this.genre%>
          </span>
        </div>
        <div class="column is-full-mobile actions">
            <a class="button details" href="<%this.detailsLink%>"><%this.detailsText%></a>
        </div>
    </div>
</div>
`;

var TemplateEngine = function (html, options) {
  var re = /<%(.+?)%>/g,
    reExp = /(^( )?(var|if|for|else|switch|case|break|{|}|;))(.*)?/g,
    code = 'with(obj) { var r=[];\n',
    cursor = 0,
    result,
    match;
  var add = function (line, js) {
    js ? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
      (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
    return add;
  };
  while (match = re.exec(html)) {
    add(html.slice(cursor, match.index))(match[1], true);
    cursor = match.index + match[0].length;
  }
  add(html.substr(cursor, html.length - cursor));
  code = (code + 'return r.join(""); }').replace(/[\r\t\n]/g, ' ');
  try {
    result = new Function('obj', code).apply(options, [options]);
  } catch (err) {
    console.error("'" + err.message + "'", " in \n\nCode:\n", code, "\n");
  }
  return result;
};

let addDynamicFilter = function ($, $agendaWrapper) {
  let $filterWrapper = $(`
<div class="column filter-container is-3">
    <div class="filter">
        <div class="filter-collapse-button" data-toggle="collapse" data-target=".filter-collapse">Filter</div>
    </div>
</div>
`);
  $agendaWrapper.append($filterWrapper);

  let $filterForm = $('.content-wrapper > form');
  $filterForm.addClass('filter-collapse collapse');
  $filterWrapper.find('.filter').append($filterForm);

  let values = [];
  $('#Genre option').each((index, elem) => {
    let value1 = $(elem).html();
    values.push({
      index: index,
      value: value1 === 'Alles' ? '' : value1,
      text: value1.toLowerCase(),
      selected: $(elem).prop('selected')
    });
  });
  $filterForm.prepend($(TemplateEngine(filterTemplate, { filters: values })));
  $filterForm.prepend('<h3>Genre</h3>');
  $filterForm.find('input[name="Search"]').attr('placeholder', 'jouw zoekterm');

  $filterForm.change(function () {
    selected_value = $("input[name='Genre']:checked").val();
    console.log('selected ' + selected_value);
    this.submit();
  });

};

let addHeaderText = function ($) {
  $('.at-custom-header').append($(TemplateEngine(headerTemplate, {})));
  $('.navbar-collapse').append(`<div class="header-button">
    <a href="https://www.mortsel.be/Leven_en_samenleven/Beleven_en_vrije_tijd/UiTPAS/Verkooppunten" target="_blank">KOOP HIER JE UiTPAS</a>
</div>`);
};

let addAgenda = function ($, $agendaWrapper) {
  let $agendaNode = $(`<div class="agenda-list column is-9"></div>`);
  $agendaWrapper.append($agendaNode);

  $('.list-at-shows .item-container').each(function (index, elem) {
    var datum = $(elem).find('.day-name.short').html() + ' ' + $(elem).find('.day-number.short').html() + ' ' + $(elem).find('.month-name.long').html() + ' om ' + $(elem).find('.at-show-starttime.at-property-value').html();

    let genre = $(elem).find('.at-show-genre .at-property-value').html();
    if (genre) {
      genre = genre.toLowerCase();
    }
    $agendaNode.append($(TemplateEngine(itemTemplate, {
      imageSrc: $(elem).find('.at-event-image').attr('src'),
      titel: $(elem).find('.at-show-title .at-property-value').html(),
      subtitel: $(elem).find('.at-show-subtitle .at-property-value').html(),
      datum: datum,
      genre: genre,
      locatie: $(elem).find('.at-show-location .at-property-value').html(),
      detailsLink: $(elem).find('.btn').attr('href'),
      detailsText: $(elem).find('.btn').html(),
      statusSlug: convertToSlug($(elem).find('.at-show-status .at-property-value').html()) + '' + convertToSlug($(elem).find('.at-show-warning .at-property-value').html()),
      status: $(elem).find('.at-show-status .at-property-value').html() || $(elem).find('.at-show-warning .at-property-value').html()
    })));
  });
};

const doDetail = function ($) {
    let date = $('.at-show-displaydate.date').html().split(new Date().getFullYear().toString())[0];
    let locatie = $('.at-show-location.at-show-property').html();
    let doorTime = $('.at-show-door-open-time.time').html();
    let startTime = $('.at-show-starttime.time').html();
    let endTime = $('.at-show-endtime.time').html();

    let koopTicketbutton = '';
    let ticketPrijzen = '';

    try {
      if ($('.at-show-special-status .at-show-special-status-label').length > 0) {
        koopTicketbutton = $('.at-show-special-status').html();
      } else if (jsonCart.Shows[0].EditData.Items.length > 0 && document.getElementById('at-shopping-cart')) {
        koopTicketbutton = `<button class="js-buy-tickets">KOOP TICKETS</button>`;
      } else {
        koopTicketbutton = `<a class="button btn btn-default btn-block" href="${document.getElementById('loginLink').href}">LOG IN</a>`;
      }
      jsonCart.Shows[0].EditData.Items.forEach((item) => {
        ticketPrijzen += `<div class="price-item">${item.Name} <span class="price">€${item.Price}</span></div>`
      });
    } catch (e) {
      console.log('something went wrong with scraping detail data.')
    }

    $('.at-show-image').append(`
  <div class="show-details-overlay">
  <h3>${date}</h3>
    <div class="location">
        <span class="label locationlabel">
            <svg width="14" height="19" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.966 7.102A6.951 6.951 0 007 .137 6.951 6.951 0 00.034 7.102C.034 10.961 7 18.166 7 18.166s6.966-7.205 6.966-11.064zm-10.21-.136A3.265 3.265 0 017 3.722a3.242 3.242 0 013.244 3.244A3.242 3.242 0 017 10.21a3.265 3.265 0 01-3.244-3.244z"
                    fill="#fff" fill-rule="nonzero"/></svg>
        </span>
        <span>${locatie}</span>
    </div>
     <div class="uur">
     <h5>${startTime} - ${endTime} uur</h5>
     <small>Deuren open om ${doorTime} uur</small>
    </div>
    <div class="ticket-prijs">
        ${ticketPrijzen ? ticketPrijzen : ''}
    </div>
    <div class="koop-tickets">
        ${koopTicketbutton}
    </div>
    <div class="andere-tijden"></div>
  </div>
`);
    let $andereTijden = $('.at-show-property-container.at-show-othershows');
    $('.show-details-overlay').find('.andere-tijden').append($andereTijden);

    $('.js-buy-tickets').on('click', (e) => {
      e.preventDefault();
      document.getElementById('at-shopping-cart').scrollIntoView({
        behavior: 'smooth'
      });
    });

    $('.at-show-header').append(`<div class="show-beschrijving">${$('.at-show-details').html()}</div>`);
  }
;

const addBanner = function ($) {
  $('footer').prepend(`
  <div class="container">
    <div class="banner columns">
        <div class="banner-content column is-full">
        <div class="banner-background">
            <div class="text-content">
                <h5>Koop tickets met korting met </h5>
                <svg width="128" height="47" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fill-rule="evenodd"><path d="M46.102 0l-1.666.248 1.57 10.503 1.666-.252zM33.75 9.91c1.033.06 1.35.099 1.416.53.06.403-.481.683-1.161.785-1.112.165-2.13-.65-2.13-.65l-.748 1.349s1.219 1.038 3.15.75c1.682-.25 2.74-1.331 2.574-2.456-.204-1.363-1.201-1.655-2.546-1.737-1.148-.071-1.608-.102-1.666-.502-.06-.405.476-.712 1.1-.805.888-.134 1.724.324 1.724.324l.652-1.347s-1.107-.658-2.593-.436c-1.806.269-2.682 1.452-2.528 2.479.187 1.252 1.41 1.637 2.757 1.717M40.484 6.222c1.1-.165 1.741.522 1.854 1.085l-3.266.489c-.03-.591.343-1.414 1.412-1.574m1.045 5.368c1.597-.238 2.497-1.34 2.497-1.34l-1.02-1.124s-.554.765-1.706.936c-1.04.156-1.835-.493-2.048-1.056l4.92-.736c-.025-.251-.06-.503-.08-.627-.303-2.028-2.027-3.204-3.833-2.935-1.903.285-3.079 2.02-2.79 3.953.29 1.93 2.06 3.229 4.06 2.929M24.63 8.748l1.292-.193.436 2.917c.209 1.403 1.32 2.188 2.599 1.999.959-.144 1.519-.67 1.519-.67l-.814-1.27s-.285.284-.658.342c-.445.064-.898-.107-1.02-.915l-.395-2.652 1.986-.296-.224-1.501-1.986.296-.294-1.957-1.668.247.294 1.96-1.292.192.225 1.5zM2.146 10.632l3.73 4.17 2.354-5.08.976 6.528 1.666-.248L9.42 6.277l-1.544.23-2.435 5.365-3.9-4.42L0 7.684l1.455 9.727 1.665-.25zM22.208 14.307l-.643-4.305s.325-.959 1.34-1.11c.486-.073.815.034.815.034l.358-1.588s-.574-.127-1.17-.038c-1.222.185-1.623 1.394-1.623 1.394l-.144-.958-1.583.236.982 6.584 1.668-.249zM15.028 10.069c1.125-.168 1.95.604 2.104 1.631.153 1.029-.41 2.007-1.535 2.176-1.125.168-1.952-.602-2.103-1.633-.156-1.027.409-2.005 1.534-2.175m.803 5.364c1.957-.293 3.286-2.055 2.995-3.985-.29-1.945-2.072-3.226-4.03-2.934-1.96.293-3.29 2.04-3 3.985.29 1.932 2.073 3.226 4.035 2.934M1.519 19.026l.002.06c12.66-.235 25.317-.47 37.985-.7l2.559 18.216C29.8 39.877 17.559 43.147 5.317 46.415l.009.04 46.82-6.578-3.852-27.425-46.775 6.574z"/><path d="M13.916 35.952c-.83.02-1.37-.389-1.581-1.163a6.656 6.656 0 01-.176-.86 2663.816 2663.816 0 00-1.57-10.992l-4.825.286c.013.19 1.123 8.24 1.686 12.142.084.594.22 1.19.406 1.76.556 1.698 1.708 2.77 3.554 3.054 1.585.247 3.117-.006 4.608-.558 1.09-.407 2.039-1.018 2.799-1.897 1.058-1.22 1.359-2.65 1.154-4.178-.478-3.585-1.545-10.927-1.583-11.065-1.234.071-2.455.142-3.712.218.014.193.97 7.35 1.492 10.78.252 1.644-.94 2.44-2.252 2.473M36.344 21.419l-10.916.645.509 3.613c1.05-.098 2.073-.194 3.18-.3l1.52 10.813c1.527-.34 2.98-.667 4.495-1.007L33.7 24.992l3.084-.433-.44-3.14zM20.531 27.291l1.51 10.745c1.47-.329 2.904-.652 4.36-.976l-1.442-10.256c-1.488.162-2.94.322-4.428.487M19.842 22.392l.529 3.758 4.434-.436-.502-3.582c-1.483.087-2.951.174-4.461.26M127.486 20.209c-.247-1.756-.934-3.213-2.066-4.374-1.13-1.158-2.44-1.908-3.931-2.241-1.492-.334-3.97-.612-7.436-.832-1.261-.082-2.124-.234-2.588-.456a1.35 1.35 0 01-.808-1.094c-.158-1.138.703-1.841 2.586-2.104 2.268-.32 3.903.388 4.904 2.118l6.862-3.116c-2.475-4.227-6.578-5.94-12.313-5.132-3.78.529-6.557 1.794-8.33 3.793-1.774 1.997-2.48 4.288-2.116 6.874.284 2.01 1.229 3.66 2.84 4.95 1.61 1.289 4.949 2.048 10.017 2.275 1.327.073 2.266.237 2.815.495.547.259.863.68.945 1.27.158 1.125-.85 1.839-3.022 2.146-2.791.39-4.68-.47-5.664-2.584l-7.822 2.533c2.39 5.346 7.015 7.536 13.877 6.57 3.754-.526 6.665-1.814 8.733-3.86 2.068-2.047 2.906-4.458 2.517-7.231M85.703 23.547l1.158-8.274 3.396 7.633-4.554.64zM81.967 7.724l-4.84 28.64 7.017-.985.932-5.641 7.543-1.06 2.348 5.18 8.819-1.238L91.102 6.44l-9.135 1.284zM63.397 22.132l-2.887.407-.744-5.303 3.175-.447c2.352-.332 3.65.362 3.89 2.074.255 1.822-.888 2.911-3.434 3.269m9.993-9.043c-1.11-1.252-2.49-2.102-4.145-2.553-1.655-.449-3.98-.465-6.978-.045l-12.025 1.693 3.853 27.417 8.766-1.232-1.4-9.962 4.89-.687c3.121-.44 5.5-1.594 7.146-3.464 1.645-1.868 2.283-4.109 1.917-6.72-.243-1.715-.916-3.198-2.024-4.447"/></g></svg>
                <div class="uitpas-button">
                  <a href="https://www.mortsel.be/Leven_en_samenleven/Beleven_en_vrije_tijd/UiTPAS/Verkooppunten" target="_blank">KOOP HIER JE UiTPAS</a>
                </div>
          </div>
        </div>
        </div>
    </div>
  `);
};

const doAccount = ($) => {
  $(".content-wrapper").wrap(`<div class='columns account-content'><div class='column is-9'></div></div>`);
  let accountContent = $(".dropdown-menu.dropdown").html();
  if (accountContent) {
    $(".account-content").prepend(`
       <div class="column is-3">
            <section class="account-menu">
                <hgroup><h2>Account</h2></hgroup>
                <ul class="sidebar-nav">
                    ${accountContent}
                </ul>
            <section>
       </div>
    `);
  }
};

$(document).ready(function ($) {
  let $agendaWrapper = $(`<div class="columns"></div>`);
  $('.main-content').append($agendaWrapper);

  addHeaderText($);

  if ($('.at-controller-Shows').length > 0) {
    // DO INDEX page specific stuff
    addDynamicFilter($, $agendaWrapper);
    addAgenda($, $agendaWrapper);
  }

  if ($('.at-action-Details').length > 0) {
    // DO detail page specific stuff
    doDetail($);
  }

  if ($('.at-controller-Account').length > 0) {
    doAccount($);
  } else if ($('.at-controller-OrderHistory').length > 0) {
    doAccount($);
  }

  addBanner($);

// When the user scrolls the page, execute stickyFunction
  window.onscroll = function () {
    stickyFunction()
  };

// Get the navbar
  var navbar = $(".navbar");

// Get the offset position of the navbar
  var sticky = navbar.offset().top;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function stickyFunction() {
    if (window.pageYOffset >= sticky) {
      navbar.addClass("sticky");
    } else {
      navbar.removeClass("sticky");
    }
  }
});

function convertToSlug(Text) {
  if (Text) {
    return Text
      .toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-')
      ;
  } else {
    return '';
  }
}
